import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import HomePage from './components/Pages/HomePage';
import Game from './components/Pages/Game';
import HighScores from './components/Pages/HighScores';
import About from './components/Pages/About';
import WinScreen from './components/WinScreen/WinScreen';
import LoadingScreen from './components/LoadingScreen/LoadingScreen';
import './assets/css/index.css';

// Import all game assets
import spiderLogo from './assets/images/logo2.png';
import gameBg from './assets/images/game_bg.jpg';
import spiderWebBg from './assets/images/spider-web-background.png';
import closedCard from './assets/images/closed_card-spider.png';
import trophy from './assets/images/trophy.png';
import undo from './assets/images/undo.png';
import rules from './assets/images/rules.png';
import help from './assets/images/help.png';
import restart from './assets/images/restart.svg';
import clock from './assets/images/clock.svg';

// Import all card images
import card0S from './assets/images/0S.png';
import card2S from './assets/images/2S.png';
import card3S from './assets/images/3S.png';
import card4S from './assets/images/4S.png';
import card5S from './assets/images/5S.png';
import card6S from './assets/images/6S.png';
import card7S from './assets/images/7S.png';
import card8S from './assets/images/8S.png';
import card9S from './assets/images/9S.png';
import cardAS from './assets/images/AS.png';
import cardJS from './assets/images/JS.png';
import cardKS from './assets/images/KS.png';
import cardQS from './assets/images/QS.png';

function App() {
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const assets = [
      // UI Assets
      spiderLogo,
      gameBg,
      spiderWebBg,
      closedCard,
      trophy,
      undo,
      rules,
      help,
      restart,
      clock,
      
      // Card Assets
      card0S,
      card2S,
      card3S,
      card4S,
      card5S,
      card6S,
      card7S,
      card8S,
      card9S,
      cardAS,
      cardJS,
      cardKS,
      cardQS
    ];

    let loadedAssets = 0;
    const totalAssets = assets.length;

    const loadAsset = (asset) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = asset;
        
        if (img.complete) {
          loadedAssets++;
          setProgress(Math.round((loadedAssets / totalAssets) * 100));
          resolve();
        } else {
          img.onload = () => {
            loadedAssets++;
            setProgress(Math.round((loadedAssets / totalAssets) * 100));
            resolve();
          };
          img.onerror = () => {
            loadedAssets++;
            setProgress(Math.round((loadedAssets / totalAssets) * 100));
            resolve();
          };
        }
      });
    };

    const preloadAssets = async () => {
      try {
        const loadPromises = assets.map(asset => loadAsset(asset));
        await Promise.all(loadPromises);
        
        // Only hide loading screen after all assets are loaded
        setLoading(false);
      } catch (error) {
        console.error('Error loading assets:', error);
        // Still hide loading screen even if there's an error
        setLoading(false);
      }
    };

    preloadAssets();
  }, []);

  if (loading) {
    return <LoadingScreen progress={progress} />;
  }

  return (
    <Router>
      <Switch>
        <Route exact path="/" component={HomePage} />
        <Route path="/game" component={Game} />
        <Route path="/highscores" component={HighScores} />
        <Route path="/about" component={About} />
        <Route path="/finish" component={WinScreen} />
      </Switch>
    </Router>
  );
}

export default App;
